/* ===== MOBILE NAV ===== */
const burgerBtn = document.getElementById("burgerBtn");
const navLinks = document.getElementById("navLinks");
const navOverlay = document.getElementById("navOverlay");
if (burgerBtn) {
  burgerBtn.addEventListener("click", () => {
    navLinks.classList.toggle("open");
    navOverlay.classList.toggle("open");
  });
}
function closeMobileNav(){
  if (!navLinks) return;
  navLinks.classList.remove("open");
  navOverlay.classList.remove("open");
}
document.querySelectorAll(".navitem > button").forEach(btn => {
  btn.addEventListener("click", (e) => {
    if (window.innerWidth <= 1024) {
      e.currentTarget.parentElement.classList.toggle("open");
    }
  });
});

/* ===== AUTO-SCROLL SPEED (set actual duration from measured width so
   speed stays constant in px/sec no matter how much repeated content
   was needed to cover the screen) ===== */
function setScrollSpeed(trackSelector, groupSelector, pxPerSecond){
  document.querySelectorAll(trackSelector).forEach(track => {
    const group = track.querySelector(groupSelector);
    if (!group || !group.offsetWidth) return;
    track.style.animationDuration = (group.offsetWidth / pxPerSecond) + "s";
  });
}
setScrollSpeed(".reviews-track", ".reviews-group", 60);

/* ===== PRODUCT GRID SCROLL ===== */
function scrollGrid(sectionId, dir){
  const grid = document.getElementById("productGrid-" + sectionId);
  if (grid) grid.scrollBy({ left: dir * 320, behavior: "smooth" });
}

/* ===== CART DRAWER (native /cart AJAX API — no token, no localStorage) ===== */
function money(cents){
  return "$" + (cents / 100).toFixed(2);
}

/* ===== FREE BONUS DESIGN (read-only) =====
   The "Buy 1 Get 1 Free" (BOGO) automatic discount (Buy X Get Y, buy 1 get 1
   free from the 8 tattoo designs, configured in Admin) picks the free item
   itself — always the cheapest qualifying unit(s) already in the cart —
   and can trigger more than once per order. There's no picker anymore,
   just a readout of what Shopify's discount engine has already made free.
   A line counts as "free" whenever Shopify has applied a discount to it
   (total_discount > 0); since this discount can't combine with any other,
   that's a reliable signal straight from the cart API.

   Mystery Tattoo is excluded from this discount in Admin, so it's also
   left out of the "add one more to unlock" hint below — it never counts
   toward earning a free item and is never eligible to be the free one. */
const MYSTERY_TATTOO_TITLE = "Mystery Tattoo";
const FREE_SHIPPING_THRESHOLD_CENTS = 4500;

function isEligibleForBundle(item){
  return item.product_title !== MYSTERY_TATTOO_TITLE;
}

function eligibleItemCount(cart){
  let count = 0;
  cart.items.forEach(i => { if (isEligibleForBundle(i)) count += i.quantity; });
  return count;
}

function freeBonusLines(cart){
  return cart.items.filter(i => i.total_discount > 0);
}

function updateFreeGiftUI(cart){
  const wrap = document.getElementById("freeGift");
  if (!wrap) return;
  const readout = document.getElementById("freeGiftReadout");
  const freeLines = freeBonusLines(cart);

  if (freeLines.length) {
    wrap.hidden = false;
    if (readout) readout.textContent = "Your free tattoo: " + freeLines.map(i => i.product_title).join(", ");
    return;
  }

  // BOGO pairs items two at a time, so an odd eligible count always has one
  // unpaired unit one design away from earning its free match.
  if (eligibleItemCount(cart) % 2 === 1) {
    wrap.hidden = false;
    if (readout) readout.textContent = "Add 1 more design to get one free.";
    return;
  }

  wrap.hidden = true;
}

/* ===== MYSTERY TATTOO UPSELL =====
   Shows the cart-drawer upsell once there's anything in the cart. Mystery
   Tattoo is a normal add-to-cart item (handled by the generic
   [data-add-to-cart] listener below) — it's just excluded from the Buy 1
   Get 1 Free (BOGO) discount in Admin, so nothing here needs to
   special-case it beyond display. */
function updateMysteryUpsell(cart){
  const upsell = document.getElementById("mysteryUpsell");
  if (!upsell) return;
  upsell.hidden = !(cart.items && cart.items.length > 0);
}

/* ===== SHIPPING PROGRESS METER =====
   Reads cart.total_price straight from Shopify's cart API (already net of
   the BOGO discount), so "$X away from free shipping" always matches what
   checkout will actually charge. */
function updateShippingMeter(cart){
  const wrap = document.getElementById("shippingMeter");
  if (!wrap) return;
  const text = document.getElementById("shippingMeterText");
  const fill = document.getElementById("shippingMeterFill");
  if (!cart.items || !cart.items.length) {
    wrap.hidden = true;
    return;
  }
  wrap.hidden = false;
  const remaining = FREE_SHIPPING_THRESHOLD_CENTS - cart.total_price;
  const pct = Math.min(100, (cart.total_price / FREE_SHIPPING_THRESHOLD_CENTS) * 100);
  if (fill) fill.style.width = pct + "%";
  if (text) {
    text.innerHTML = remaining > 0
      ? money(remaining) + " away from <strong>free shipping</strong>"
      : "<strong>Free shipping</strong> unlocked";
  }
}

/* ===== COMPLETE-YOUR-LOOK CROSS-SELL =====
   Shows once there's anything in the cart, and hides any of the up-to-3
   curated designs that's already in the cart (matched by handle) so the
   same design never appears twice in the drawer. */
function updateCompleteLookUpsell(cart){
  const wrap = document.getElementById("completeLookUpsell");
  if (!wrap) return;
  const cartHandles = new Set((cart.items || []).map(i => i.handle));
  let visibleCount = 0;
  wrap.querySelectorAll("[data-crosssell-item]").forEach(el => {
    const inCart = cartHandles.has(el.getAttribute("data-product-handle"));
    el.hidden = inCart;
    if (!inCart) visibleCount++;
  });
  wrap.hidden = !(cart.items && cart.items.length > 0) || visibleCount === 0;
}

function renderCart(cart){
  const body = document.getElementById("drawerBody");
  const countEl = document.getElementById("cartCount");
  if (countEl) {
    countEl.style.display = cart.item_count ? "flex" : "none";
    countEl.textContent = cart.item_count;
  }
  updateShippingMeter(cart);
  updateFreeGiftUI(cart);
  updateCompleteLookUpsell(cart);
  updateMysteryUpsell(cart);
  if (!body) return;
  if (!cart.items.length) {
    body.innerHTML = `<p class="empty-note">Your cart is empty.</p>`;
    renderCartFoot(null);
    return;
  }
  body.innerHTML = cart.items.map((item, idx) => {
    // A line's total_discount is Shopify's own record of how much of it
    // the Buy 1 Get 1 Free (BOGO) discount zeroed out — dividing by the
    // per-unit price gives how many units in this line are actually free.
    const freeUnits = item.price > 0 ? Math.round(item.total_discount / item.price) : 0;
    const freeTag = freeUnits > 0
      ? ` <span class="free-gift-tag">${freeUnits > 1 ? freeUnits + '&times; Free' : 'Free'}</span>`
      : '';
    return `
    <div class="drawer-item">
      <span>${item.product_title} &times; ${item.quantity}${freeTag}</span>
      <span class="drawer-item-right">
        <span class="mono">${money(item.line_price)}</span>
        <button type="button" class="drawer-item-remove" data-remove-line="${idx + 1}" data-current-qty="${item.quantity}" aria-label="Remove one ${item.product_title}">&times;</button>
      </span>
    </div>
  `;
  }).join("");
  renderCartFoot(cart);
}

async function changeCartLine(line, quantity){
  try {
    const res = await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
    if (!res.ok) {
      const err = await res.json();
      alert(err.description || "Couldn't update your cart.");
      return;
    }
    const cart = await res.json();
    renderCart(cart);
  } catch (err) {
    console.error("Cart update failed:", err);
    alert("Cart update failed — check your connection and try again.");
  }
}

/* Uses Shopify's own cart totals (not a client-side estimate) so this always
   matches checkout exactly, including any Automatic Discount applied in Admin. */
function renderCartFoot(cart){
  const foot = document.getElementById("drawerFoot");
  if (!foot) return;
  let extra = "";
  if (cart && cart.item_count > 0) {
    extra += `<div class="drawer-item"><span>Subtotal</span><span class="mono">${money(cart.total_price)}</span></div>`;
  }
  foot.innerHTML = extra + `<button class="checkout-btn" id="checkoutBtn" onclick="goToCheckout()">Checkout</button>`;
}

function toggleCart(open){
  document.getElementById("drawer").classList.toggle("open", open);
  document.getElementById("overlay").classList.toggle("open", open);
}

/* Lightweight "it worked" cue for add-to-cart that doesn't hijack the screen —
   the drawer used to auto-open on every add, which made picking several
   different designs in a row (for the bundle discount) annoying. */
function pulseCartIcon(){
  const countEl = document.getElementById("cartCount");
  if (!countEl) return;
  countEl.classList.remove("cart-count-pulse");
  void countEl.offsetWidth; // restart animation if clicked again quickly
  countEl.classList.add("cart-count-pulse");
}

async function refreshCart(){
  const res = await fetch("/cart.js");
  const cart = await res.json();
  renderCart(cart);
  return cart;
}

async function addToCart(variantId, quantity){
  quantity = quantity || 1;
  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
    });
    if (!res.ok) {
      const err = await res.json();
      alert(err.description || "Couldn't add that to your cart.");
      return;
    }
    await refreshCart();
    pulseCartIcon();
  } catch (err) {
    console.error("Add to cart failed:", err);
    alert("Add to cart failed — check your connection and try again.");
  }
}

function goToCheckout(){
  window.location.href = "/checkout";
}

document.addEventListener("click", function(e){
  const addBtn = e.target.closest("[data-add-to-cart]");
  if (addBtn) {
    e.preventDefault();
    const variantId = addBtn.getAttribute("data-variant-id");
    if (variantId && !addBtn.disabled) addToCart(variantId, 1);
    return;
  }
  const removeBtn = e.target.closest("[data-remove-line]");
  if (removeBtn) {
    e.preventDefault();
    const currentQty = parseInt(removeBtn.getAttribute("data-current-qty"), 10);
    changeCartLine(parseInt(removeBtn.getAttribute("data-remove-line"), 10), currentQty - 1);
    return;
  }
});

/* ===== INITIAL RENDER ===== */
renderCart(window.__CART__);
